export const SCHEME_DEAL_TABLE_HEADERS = [
  { model: "Model" },
  { mmCode: "M&M" },
  { advertisedInstalment: "Advertised Instalment (excl R69 fee)" },
  { retailInclVAT: "Retail Incl. VAT" },
  { rateToClient: "Rate to Client (Optional)" },
  { rateToClientPercent: "Rate to Client %" },
  { deposit: "Deposit" },
  { period: "Period (Optional)" },
  { balloonPercent: "Balloon" },
  { balloon: "Balloon R' (Optional)" },
  { totalCostOfCredit: "Total Cost of Credit (Optional)" },
  { dealAssistance: "Deal assistance" },
  { notes: "Notes" },
  { dealStatus: "Deal Status" },
  { expiryDate: "Expiry Date" },
];

export const LIST_PRICE_DEAL_TABLE_HEADERS = [
  { model: "Model" },
  { mmCode: "M&M" },
  // { advertisedInstalment: "Advertised Instalment (excl R69 fee)" },
  { retailInclVAT: "Retail Incl. VAT" },
  { dealAssistance: "Deal assistance" },
  { notes: "Notes" },
  { dealStatus: "Deal Status" },
  { expiryDate: "Expiry Date" },
];
